// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Loader = require("../../uikit/reason/atoms/Loader/Loader.bs.js");
let QuestionPopover = require("../../components/MyClientsWidget/components/QuestionPopover/QuestionPopover.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let MyDraftsWidgetDraftList = require("./MyDraftsWidgetDraftList.bs.js");

function MyDraftsWidgetRelay(props) {
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h2", {
            children: "My Drafts",
            className: "text-gray-700 text-2xl font-medium"
          }),
          JsxRuntime.jsx(QuestionPopover.make, {
            children: "Drafts of your broadcast property posts. Drafts are available for 2 months."
          })
        ],
        className: "flex gap-4 items-center flex-row mb-4"
      }),
      JsxRuntime.jsx(React.Suspense, {
        children: JsxRuntime.jsx(MyDraftsWidgetDraftList.make, {
          query: props.query,
          viewMoreMode: props.viewMoreMode
        }),
        fallback: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Loader.make, {
            loadingText: "Loading drafts..."
          }),
          className: "h-[476px] flex items-center justify-center"
        })
      })
    ],
    className: "bg-white p-5 rounded shadow-sm"
  });
}

let make = MyDraftsWidgetRelay;

exports.make = make;
/* react Not a pure module */
